import React from 'utils/react';
import Container from './Container';

const Panel = props => <Container>{props.children}</Container>;

export default React.memo(Panel);
